import type { DemandManagementStatus } from '@api/generated/models';
import { HttpService, type VisibaApiPromise } from '@services/http.service';
import { Singleton } from '@visiba/instantiation';

@Singleton()
export class DemandManagementApiService {
	constructor(private readonly httpService: HttpService) {}

	public async getMessagingOpenStatus(receptionId: number): VisibaApiPromise<DemandManagementStatus> {
		return this.httpService.get(`client/v2/receptions/${receptionId}/demand-management/messaging`);
	}

	public async getTriageOpenStatus(receptionId: number): VisibaApiPromise<DemandManagementStatus> {
		return this.httpService.get(`client/v2/receptions/${receptionId}/demand-management/triage-entry`);
	}
}
